import React, {useEffect, useState} from 'react';
import './BasicReferralStyle.css';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import { useDispatch } from 'react-redux';
import Notification from '../../../../components/Notification/Notification';
import {
  basicReferralInvitedUserListRequest
} from "../../../../redux/actions/app/basicActions";
import {Helmet} from "react-helmet";
import BtnIcons from "../../../../api/images/btnIcons";

function BasicReferralAccountInfo(props) {
  const title = 'Basic Referral Account';
  // -- props --//
  const row = props.location.state.row;

  // -- component const --//
  // 테이블 헤더
  const tHead = [
    '로그 번호',
    '회원 번호',
    '친구 여부',
    '삭제 여부',
    '삭제 일시',
    '생성 일시',
  ];

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(100);
  const [totalCount, setTotalCount] = useState(0);
  const [invitedList, setInvitedList] = useState([]);

  // -- func & handler --//
  const goBack = () => {
    window.history.back();
  };
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
        basicReferralInvitedUserListRequest({
          page: page,
          pageLength: Number(pageLength),
          inviterAccountNo: row.accountNo,
          invitedAccountNo: 0,
          callback: (data) => {
            console.log('요청 결과: ', data);
            setTotalCount(data?.totalCount);
            // setTbody(data?.list);

            // 인덱스를 추가하여 새로운 배열을 생성(중복 키 방지)
            const listWithIndex = data?.list.map((item, index) => ({
              index: index + 1, // 인덱스는 1부터 시작(번호 표기시 편의를 위해)
              ...item,
            }));

            setInvitedList(listWithIndex);
          },
          error: (e) => {
            console.log(e);
            setNotificationMessage(e.toString());
            setShowNotification(true);
          },
        }),
    );
  }
  // -- react hooks --//
  useEffect(() => {
    fetchList();
  }, [row]);

  // -- render --//
  return (
      <div className="page">
        <Helmet>
          <title>{title}</title>
        </Helmet>

        <div className="topSection flowRoot">
          <div className="leftSection">
            <img src={BtnIcons.backIcon} className="backIcon" onClick={goBack}  alt='goBack'/>
            <p className="titleText">{title}</p>
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="divTaps">
            <div className="perplayUserInfoSection">
              <div className="idSection">
                <p className="idTag">ID #</p>
                <p>{row.accountNo}</p>
              </div>

              <div className="nickNameSection">
                <p className="nickNameTag">
                  초대 코드 입력 수 ({totalCount || 0}명)
                </p>
                <div style={{
                  width: '50%',
                  maxHeight: 180,
                  overflow: 'auto'
                }}>

                  <table>
                    <thead>
                    <tr>
                      {tHead.map((i, index) => (
                          <th key={index} className="">
                            {i}
                          </th>
                      ))}
                    </tr>
                    </thead>
                    <tbody>
                    {
                      invitedList?.length > 0 ?
                          invitedList?.map((row, index) => (
                              <tr
                                  key={index}
                              >
                                <td>{row?.logNo}</td>
                                <td>{row?.invitedAccountNo}</td>
                                <td>{row?.active ? 'O' : 'X'}</td>
                                <td>{row?.enabled ? 'X' : 'O'}</td>
                                <td>{timeFormAPI.changeDataLog(row?.deletedAt)}</td>
                                <td>{timeFormAPI.changeDataLog(row?.createdAt)}</td>
                              </tr>
                          ))
                          : (
                              <tr>
                                <td
                                    colSpan={tHead.length}
                                    style={{
                                      textAlign: 'center',
                                      backgroundColor: '#FAFBFC' }}
                                >
                                  등록된 로그 정보가 없습니다.
                                </td>
                              </tr>
                          )
                    }
                    </tbody>
                  </table>

                </div>
              </div>

              {/* 추가 */}
              <div className="mailSection">
                <p className="emailTag">초대 코드</p>
                <div className="mailInput">
                  <p className="emailAddr">{row.inviteCode}</p>
                </div>
              </div>

              <div className="mailSection">
                <p className="emailTag">등급(포인트)</p>
                <div className="mailInput">
                  <p className="emailAddr">{row.point}</p>
                </div>
              </div>

              <div className="registDateTimeSection">
                <p className="regDateTag">가입 일시</p>
                <p>
                  {timeFormAPI.changeDataLog(row.createdAt)}
                </p>
              </div>

            </div>

            {showNotification ? (
                <Notification
                    close={() => setShowNotification(false)}
                    message={notificationMessage}
                />
            ) : null}
        </div>

        {showNotification ? (
            <Notification
                close={() => setShowNotification(false)}
                message={notificationMessage}
            />
        ) : null}
      </div>

  );
}

export default BasicReferralAccountInfo;
